import { MUTATION_KEYS } from "hooks/data/queryKeys";
import React from "react";
import { useIsMutating } from "react-query";
import { useSelector } from "store/hooks";
import { EDialogAttributeName } from "../../constants";
import AnnualGrossPremiumForm from "./AnnualGrossPremiumForm/AnnualGrossPremiumForm";
import HullDeductibleForm from "./HullDeductibleForm/HullDeductibleForm";
import HullPremiumCalculationForm from "./HullPremiumCalculationForm/HullPremiumCalculationForm";
import AssistanceOptionsForm from "./AssistanceOptionsForm/AssistanceOptionsForm";
import HullDeductibleOptionsForm from "./HullDeductibleOptionsForm/HullDeductibleOptionsForm";
import MtplInsuranceLimitsForm from "./MtplInsuranceLimitsForm/MtplInsuranceLimitsForm";

export const SettingForm = () => {
  const dialog = useSelector((s) => s.fleetForm.dialog);

  const isCreateLoading = !!useIsMutating({
    mutationKey: [MUTATION_KEYS.createFleetVehicleDefaultSetting],
  });
  const isUpdateLoading = !!useIsMutating({
    mutationKey: [MUTATION_KEYS.updateFleetVehicleDefaultSetting],
  });

  const settingId = dialog.data.settingId;
  const isLoading = isCreateLoading || isUpdateLoading;

  const attributeName = dialog.data.attributeName;

  const renderSettingsDialog = (attributeName) => {
    switch (attributeName) {
      case EDialogAttributeName.AnnualGrossPremium:
        return (
          <AnnualGrossPremiumForm
            settingId={settingId}
            isLoading={isLoading}
            attributeName={EDialogAttributeName.AnnualGrossPremium}
          />
        );
      case EDialogAttributeName.Deductible:
        return (
          <HullDeductibleForm
            settingId={settingId}
            isLoading={isLoading}
            attributeName={EDialogAttributeName.Deductible}
          />
        );
      case EDialogAttributeName.Calculation:
        return (
          <HullPremiumCalculationForm
            settingId={settingId}
            isLoading={isLoading}
            attributeName={EDialogAttributeName.Calculation}
          />
        );
      case EDialogAttributeName.MbCalculation:
        return (
          <HullPremiumCalculationForm
            settingId={settingId}
            isLoading={isLoading}
            attributeName={EDialogAttributeName.MbCalculation}
          />
        );
      case EDialogAttributeName.MtplInsuranceLimits:
        return (
          <MtplInsuranceLimitsForm
            settingId={settingId}
            isLoading={isLoading}
            attributeName={EDialogAttributeName.MtplInsuranceLimits}
          />
        );
      case EDialogAttributeName.HullDeductibleOptions:
        return (
          <HullDeductibleOptionsForm
            settingId={settingId}
            isLoading={isLoading}
            attributeName={EDialogAttributeName.HullDeductibleOptions}
          />
        );
      case EDialogAttributeName.AssistanceOptions:
        return (
          <AssistanceOptionsForm
            settingId={settingId}
            isLoading={isLoading}
            attributeName={EDialogAttributeName.AssistanceOptions}
          />
        );
    }
  };

  return <div>{renderSettingsDialog(attributeName)}</div>;
};
